import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/view/Login'
import MainPage from '../MainPage'
import CAPTCHALogin from '../components/CAPTCHALogin'
import AccountLogin from '../components/AccountLogin'
import ChangePassword from '../components/ChangePassword'
import PersonalMain from '../components/PersonalMain'
import Report from '../components/Report'
import PDFModal from '../components/PDFModal'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'MainPage',
      component: MainPage,
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/personalMain',
      name: 'personalMain',
      component: PersonalMain
    },
    {
      path: '/Report',
      name: 'Report',
      component: Report
    },
    {
      path: '/PDFModal',
      name: 'PDFModal',
      component: PDFModal
    },
    {
      path:'/CAPTCHALogin',
      name:'CAPTCHALogin',
      component:CAPTCHALogin
    },
    {
      path:'/AccountLogin',
      name:'AccountLogin',
      component:AccountLogin
    },
    {
      path:'/ChangePassword',
      name:'ChangePassword',
      component:ChangePassword
    },
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js